import React, { Component } from "react";

import ReactUUID from "react-uuid";
import ReactSelect from "react-select";
import { FieldTooltip } from "../../field-tooltip";

import { ResubmitTextWarning } from "../../../config/loan-application";
import { SelectAutoSearchOptionsCount } from "./../../../config/ubx";

const pillColorOptions = ["primary", "dark"];

// const RSelect = React.forwardRef((props, ref) => <ReactSelect ref={ref} {...props} />);

export default class UBXFormSelect extends Component {
    _mounted = false;

    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            error: false,
            type: "dropdown",
            attr: {},
            options: [],
            placeholder: false,
            filter: "",
            defaultValue: "",
            warning: false,
        };

        this.onFocus.bind(this);
        this.onLeave.bind(this);
        this.onSearch.bind(this);
        this.onChange.bind(this);

        this._ref = React.createRef();
    }

    componentDidUpdate() {
        // console.log("UBXFormSelect", this.props.id);
    }

    async componentDidMount() {
        this._mounted = true;

        // console.log("UBXFormSelect.componentDidMount", this.props);

        await this.initialize();
    }

    componentWillUnmount() {
        // this.uninitializeEvents();
        // this.setState({ ready: false });
        this._mounted = false;
    }

    async initialize() {
        let { value: defaultValue = "", name, onChange = false } = this.props;
        const searchable = this.isSearchable();

        await this.initializeField();

        const { /*options, */ type } = this.state;

        if (defaultValue) {
            if (searchable) {
                if (onChange) {
                    onChange(name, defaultValue);
                }

                // const result = options.find((option) => option.value === defaultValue);

                // if (result) {
                //     defaultValue = result.name;
                // }
            } else {
                if (type === "pill" && onChange) {
                    onChange(name, defaultValue);
                }
            }
        }

        if (this._mounted) {
            await this.setState({ defaultValue, ready: true });
        }

        await this.initializeEvents();
    }

    async initializeField() {
        const {
            required = true,
            disabled = false,
            readonly = false,
            options: optionsProp = [],
            multiple = false,
            pillColor = false,
        } = this.props;
        let { id = ReactUUID(), placeholder = false, sort = false, useAutoPlaceholder = true, resubmit } = this.props;

        const searchable = this.isSearchable();

        const attr = {};

        if (required) {
            attr["required"] = true;
        }

        if (disabled) {
            attr["disabled"] = true;
        }

        if (readonly) {
            attr["readOnly"] = true;
        }

        if (multiple !== false) {
            attr["multiple"] = true;
        }

        if (resubmit) {
            this.setState({ warning: ResubmitTextWarning });
        }

        if (!placeholder && useAutoPlaceholder) {
            let autoPlaceholder = "select one";
            if (multiple) {
                if (multiple === true) {
                    autoPlaceholder = "select one or more options";
                } else {
                    if (typeof multiple === "number") {
                        autoPlaceholder = ` select ${multiple} options`;
                    } else if (typeof multiple === "object") {
                        const { min = 1, max = false } = multiple;

                        autoPlaceholder = `select ${min}`;
                        if (max === false) {
                            autoPlaceholder = `${autoPlaceholder} or more`;
                        } else {
                            autoPlaceholder = `${autoPlaceholder} to ${max}`;
                        }
                        autoPlaceholder = `${autoPlaceholder} options`;
                    }
                }
            }
            placeholder = `${searchable ? "Search or" : "Please"} ${autoPlaceholder}`;
        }
        await this.setState({ id, attr, placeholder, pillColor });

        await this.manageOptions(optionsProp, sort);
    }

    initializeEvents() {
        const { id } = this.state;

        if (id) {
            const selectField = document.getElementById(id);

            if (selectField) {
                selectField.addEventListener("focus", (e) => this.onFocus(e));
                selectField.addEventListener("blur", (e) => this.onLeave(e));
                // selectField.addEventListener('keydown', e => this.onKeyDown(e));
                //selectField.addEventListener("change", (e) => this.onChange(e));

                const searchField = selectField.parentNode.querySelector('input[type="search"]');

                if (searchField) {
                    searchField.addEventListener("keyup", (e) => this.onSearch(e));
                }
            }
        }
    }

    uninitializeEvents() {
        const { id } = this.state;

        const selectField = document.getElementById(id);

        if (selectField) {
            selectField.removeEventListener("focus", (e) => this.onFocus(e));
            selectField.removeEventListener("blur", (e) => this.onLeave(e));
            // selectField.removeEventListener("change", (e) => this.onChange(e));
        }
    }

    async manageOptions(optionsProp, sort = false) {
        let { type } = this.props;

        let options = [];
        let optionValues = [];
        if (optionsProp) {
            if (optionsProp.constructor === Object) {
                for (let value in optionsProp) {
                    let name = optionsProp[value];

                    if (!optionValues.includes(value)) {
                        options.push({ name, value, label: name });
                        optionValues.push(value);
                    }
                }
            } else if (optionsProp.constructor === Array) {
                options = optionsProp.map((optionProp) => {
                    let name = "";
                    let value = "";
                    let otherData = {};

                    if (optionProp.constructor === Object) {
                        let { name: optionPropName = "", value: optionPropValue = "", ...data } = optionProp;
                        name = optionPropName;
                        value = optionPropValue;
                        otherData = data;
                    } else {
                        name = optionProp;
                        value = optionProp;
                    }

                    let option = false;
                    if (!optionValues.includes(value)) {
                        option = { name, value, label: name, ...otherData };
                        optionValues.push(value);
                    }

                    return option;
                });
                options = options.filter((option) => (option ? true : false));
            }

            if (sort) {
                options.sort((opt1, opt2) => {
                    const { name: name1 } = opt1;
                    const { name: name2 } = opt2;
                    if (name1.toLowerCase() < name2.toLowerCase()) {
                        return -1;
                    }
                    if (name1.toLowerCase() > name2.toLowerCase()) {
                        return 1;
                    }

                    return 0;
                });
            }
        }

        if (type !== "dropdown" && type !== "pill") {
            if (options.length < 5) {
                type = "pill";
                options.forEach((option) => {
                    const { value } = option;

                    if (value && value.length > 15) {
                        type = "dropdown";
                    }
                });
            } else {
                type = "dropdown";
                let optionsCharLength = 0;
                options.forEach((option) => {
                    const { value } = option;

                    optionsCharLength += value.length;
                });

                if (optionsCharLength <= 15) {
                    type = "pill";
                }
            }
        }

        if (this._mounted) await this.setState({ options, type });
    }

    isSearchable() {
        let { searchable, options } = this.props;

        if (searchable === undefined) {
            let optionsCount = 0;
            if (Array.isArray(options)) {
                optionsCount = options.length;
            } else {
                optionsCount = Object.keys(options).length;
            }

            if (optionsCount >= SelectAutoSearchOptionsCount) {
                searchable = true;
            } else {
                searchable = false;
            }
        }

        return searchable;
    }

    /* --- EVENTS --- */
    onFocus(e) {
        const { target } = e;

        target.parentNode.classList.add("field-focused");
    }

    onLeave(e) {
        const { target } = e;

        target.parentNode.classList.remove("field-focused");
    }

    onChange(e) {
        const { target } = e;
        const { name, value } = target;
        const { onChange = false, onError = false, multiple = false, resubmit = false } = this.props;
        const { type } = this.state;

        let warning = false;

        let multipleValue = [];
        if (type === "pill") {
            if (multiple) {
                const checkboxes = target
                    .closest(`.ubx-form.select`)
                    .querySelectorAll(`input[type="checkbox"][name^="${name}"]:checked`);

                checkboxes.forEach((checkbox) => {
                    multipleValue.push(checkbox.value);
                });

                warning = multipleValue.length ? false : ResubmitTextWarning;
            } else {
                const checkboxes = document.querySelectorAll(`input[type="checkbox"][name^="${name}"]:checked`);
                checkboxes.forEach((checkbox) => {
                    if (checkbox !== target) {
                        checkbox.checked = false;
                    }
                });

                warning = checkboxes.length ? false : ResubmitTextWarning;
            }
        }

        if (resubmit) {
            this.setState({ warning });
        }

        if (target.parentNode && target.parentNode.classList) {
            target.parentNode.classList.toggle(
                "field-filled",
                value || (multiple && multipleValue.length > 0) ? true : false,
            );
        }

        if (onChange) {
            if (multiple) {
                onChange(name, multipleValue, e);
            } else {
                if (type === "pill") {
                    onChange(name, target.checked ? value : "", e);

                    if (onError) {
                        onError(name, false);
                    }
                } else {
                    onChange(name, value, e);

                    if (onError) {
                        onError(name, false);
                    }
                }
            }
        }
    }

    onSelectChange(selectedOption) {
        const { name, onChange = false, multiple = false, resubmit = false } = this.props;
        const warning = selectedOption ? false : ResubmitTextWarning;

        if (onChange) {
            if (multiple) {
                onChange(
                    name,
                    selectedOption.map((opt) => opt.value),
                );
            } else {
                onChange(name, selectedOption.value);
            }
        }

        if (resubmit) {
            this.setState({ warning });
        }
    }

    async onSearch(e) {
        const currentTimestamp = new Date().getTime();
        const { name, onChange = false } = this.props;
        const { options = [], type } = this.state;
        let { searchTimeout = null } = this.state;
        const { target } = e;
        const { value: searchValue } = target;

        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        searchTimeout = setTimeout(async () => {
            let filter = "";
            let selectedOption = "";
            if (searchValue !== "" && searchValue.length >= 2) {
                selectedOption = options.find((option) => {
                    const { name } = option;

                    return searchValue === name && type !== "pill" ? true : false;
                });

                if (!selectedOption) {
                    filter = searchValue;
                }
            }

            await this.setState({ filter, lastSearch: currentTimestamp, searchTimeout: null });

            if (onChange) {
                onChange(name, selectedOption ? selectedOption.value : "");
            }
        }, 500);

        await this.setState({ searchTimeout });
    }
    /* --- /EVENTS --- */

    /* --- RENDER --- */
    renderLabel() {
        const { id } = this.state;
        const { label = false, caption = false, required = false, tooltip = "" } = this.props;

        let renderedLabel = [];
        if (label) {
            let optionalLabel = "";
            if (!required) {
                optionalLabel = <sub>(Optional)</sub>;
            }

            renderedLabel.push(
                <label key={0} htmlFor={id} title={`${label} ${optionalLabel}`}>
                    <div>
                        {label} {optionalLabel}
                    </div>
                    {tooltip && <FieldTooltip content={tooltip} />}
                </label>,
            );
        }
        if (caption) {
            renderedLabel.push(
                <span key={1} className="caption">
                    {caption}
                </span>,
            );
        }

        return renderedLabel;
    }

    renderDropdown() {
        const { id, options, /*attr,*/ placeholder, defaultValue, value } = this.state;
        const { name, prefix = false, suffix = false, multiple = false, filterOption = false } = this.props;
        const searchable = this.isSearchable();

        // const options = this.renderDropdownOptions();

        const renderedDropdown = [];

        const customProps = {};
        if (prefix) {
            customProps["pre"] = prefix;
        }
        if (suffix) {
            customProps["suf"] = suffix;
        }
        /*
        const defaultValueOption = defaultValue
            ? options.find((o) => o.value === defaultValue)
            : value
            ? options.find((o) => o.value === value)
            : {};
*/
        let defaultValueOption = null;
        if (defaultValue) {
            defaultValueOption = Array.isArray(defaultValue)
                ? defaultValue.map((dv) => options.find((o) => o.value === dv))
                : options.find((o) => o.value === defaultValue);
        }
        if (value) {
            defaultValueOption = options.find((o) => o.value === value);
        }

        const customDropdownProps = {};
        if (filterOption) {
            customDropdownProps["filterOption"] = (candidate, input) => filterOption(candidate, input, this);
        }

        // if (multiple) {
        //     customDropdownProps["menuIsOpen"] = true;
        // }

        // console.log({ customDropdownProps });

        renderedDropdown.push(
            <ReactSelect
                {...{ key: id, id, name, placeholder }}
                className="react-select"
                classNamePrefix="react-select"
                ref={this._ref}
                isSearchable={searchable}
                isMulti={multiple}
                options={options.map((o) => {
                    return { _id: o.value, label: o.name, value: o.value, ...o };
                })}
                onChange={(selected) => this.onSelectChange(selected)}
                defaultValue={defaultValueOption}
                menuPlacement="auto"
                {...customDropdownProps}
            />,
        );
        /*
        if (searchable) {
            renderedDropdown.push(
                <Fragment key={-1}>
                    <span {...customProps}>
                        <input
                            type="search"
                            list={`${id}-list`}
                            placeholder={placeholder}
                            onFocus={(e) => this.onSearch(e)}
                            onChange={(e) => this.onSearch(e)}
                            defaultValue={defaultValue}
                        />
                    </span>
                    <datalist id={`${id}-list`}>{options}</datalist>
                </Fragment>,
            );
            renderedDropdown.push(<RSelect isSearchable={true} options={this.state.options} />);
        } else {
            renderedDropdown.push(
                <span key={0} {...customProps}>
                    <select
                        id={id}
                        name={name}
                        {...attr}
                        defaultValue={defaultValue}
                        onChange={(e) => this.onChange(e)}
                    >
                        {options}
                    </select>
                </span>,
            );
        }
*/
        return renderedDropdown;
    }

    renderDropdownOptions() {
        const { options, placeholder } = this.state;
        const searchable = this.isSearchable();

        let renderDropdownOptions = [];
        if (placeholder && !searchable) {
            renderDropdownOptions.push(
                <option key={-1} value="">
                    {placeholder}
                </option>,
            );
        }

        options.forEach((option, optKey) => {
            const { name, value } = option;

            if (searchable) {
                //if (filter === "" || filterRx.test(name)) {
                renderDropdownOptions.push(
                    <option key={optKey} opt-value={value}>
                        {name}
                    </option>,
                );
                //}
            } else {
                renderDropdownOptions.push(
                    <option key={optKey} value={value}>
                        {name}
                    </option>,
                );
            }
        });

        return renderDropdownOptions;
    }

    renderPill() {
        const { id } = this.state;
        const { "sub-type": subType = false, multiple = false } = this.props;

        const options = this.renderPillOptions();
        const customClassName = [];
        if (subType) {
            customClassName.push(subType);
        }
        if (multiple) {
            customClassName.push("multiple");
        }

        return (
            <div id={id} className={`pills ${customClassName.join(" ")}`}>
                {options}
            </div>
        );
    }

    renderPillOptions() {
        const { id, options, attr, filter } = this.state;
        const { name, multiple = false, value: defaultValue = "", unselect = false } = this.props;
        const optionType = "checkbox";

        const searchable = this.isSearchable();
        //const optionType = multiple ? 'checkbox' : 'radio';

        delete attr["multiple"];
        delete attr["required"];

        let renderedPillOptions = [];

        const escapedFilter = filter.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const filterRx = new RegExp(`\\b${escapedFilter}`, "im");

        if (searchable) {
            renderedPillOptions.push(
                <input
                    className="pill-search"
                    type="search"
                    key={-1}
                    placeholder={`Search ${name}`}
                    onChange={(e) => this.onSearch(e)}
                />,
            );
        }

        options.forEach((option, optKey) => {
            const { name: optName, value } = option;
            const optionId = `${id}-${`${value}`.replace(/ /gim, "-")}`;

            //attr['name'] = multiple ? `${name}[]`  : name;
            attr["name"] = name;
            attr["value"] = value;
            attr["disabled"] = attr["readOnly"];

            let checked = false;
            if (multiple !== false) {
                if (defaultValue.includes(value)) {
                    checked = true;
                }
            } else {
                checked = defaultValue === value.toString() ? true : false;
            }
            attr["defaultChecked"] = checked;

            let pillClassName = "pill";
            if (unselect && value === "_unselect") {
                pillClassName = "pill-default";
            }

            if (searchable) {
                if (filter === "" || filterRx.test(optName) || checked) {
                    renderedPillOptions.push(
                        <label key={optKey} id={optionId} className={pillClassName}>
                            <input type={optionType} {...attr} onChange={(e) => this.onChange(e)} />
                            <span>{optName}</span>
                        </label>,
                    );
                }
            } else {
                renderedPillOptions.push(
                    <label key={optKey} id={optionId} className={pillClassName}>
                        <input
                            type={optionType}
                            {...attr}
                            onChange={(e) => this.onChange(e)}
                            onInvalid={(e) =>
                                e.target.setCustomValidity(`Please select at least one option to proceed`)
                            }
                        />
                        <span>{optName}</span>
                    </label>,
                );
            }
        });

        return renderedPillOptions;
    }

    renderInput() {
        const { type, pillColor } = this.state;
        const { disabled = false, readonly = false, className = false } = this.props;

        const customAttrs = {};

        let renderedInput = "";
        let renderedType = "";

        if (type === "dropdown") {
            renderedInput = this.renderDropdown();
            renderedType = "dropdown";
        } else if (type === "pill") {
            renderedInput = this.renderPill();
            renderedType = "pill-select";
        }

        const containerClassNames = ["field", renderedType];
        if (disabled || readonly) {
            containerClassNames.push("field-disabled");
        }

        if (pillColor && pillColorOptions.includes(pillColor)) {
            containerClassNames.push(pillColor);
        }

        if (className) {
            containerClassNames.push(className);
        }

        return (
            <div key="ubx-form-select" className={containerClassNames.join(" ")} {...customAttrs}>
                {renderedInput}
            </div>
        );
    }

    renderError() {
        const { error: errorProp = false } = this.props;
        const { error: errorState = false } = this.state;

        let renderedError = "";
        if (errorProp || errorState) {
            const error = errorProp || errorState;
            renderedError = <span className="error">{error}</span>;
        }

        return renderedError;
    }

    renderWarning() {
        const { warning: warningProp = false } = this.props;
        const { warning: warningState = false } = this.state;

        let renderedWarning = "";
        if (warningProp || warningState) {
            const warning = warningProp || warningState;
            renderedWarning = <span className="warning">{warning}</span>;
        }

        return renderedWarning;
    }

    render() {
        const { hide = false, className = "" } = this.props;
        const { ready, pillColor } = this.state;

        let rendered = "";
        if (!hide && ready) {
            rendered = (
                <div className={`ubx-form select ${pillColor ? pillColor : ""} ${className}`}>
                    {this.renderLabel()}
                    {this.renderError()}
                    {this.renderInput()}
                    {this.renderWarning()}
                </div>
            );
        }

        return rendered;
    }
    /* --- /RENDER --- */
}
